const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChefIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "110px",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    viewBox: "0 0 110 110",
    width: "110px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Multicolor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83,80c-0.615-1.333-1.698-2.394-3.043-2.982L65,73v-5.001l-3.243,3.241    c-1.125,1.125-2.651,1.757-4.242,1.757H55h-2.516c-1.591,0-3.116-0.632-4.242-1.757L45,67.999V73l-14.957,4.018    C28.698,77.606,27.615,78.667,27,80l-4,7h32h32L83,80z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,49c-0.423,0-0.741,0.102-1.004,0.243c-0.007-0.767,0.034-1.515,0-2.243H41.063    c-0.045,0.965-0.062,1.966-0.063,3v12.343c0,1.061,0.422,2.079,1.172,2.829l6.071,6.068c1.125,1.125,2.651,1.757,4.242,1.757H55    h2.516c1.591,0,3.116-0.632,4.242-1.757l6.071-6.068c0.75-0.75,1.172-1.768,1.172-2.829v-3.53c2.226-0.873,3-4.66,3-7.59    C72,50.111,71,49,70,49z",
    style: {
      fill: "#BF8662"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 84,
    r: 2,
    style: {
      fill: "#F3B607"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 77,
    r: 2,
    style: {
      fill: "#F3B607"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.063,47c-0.034,0.728-0.052,1.476-0.059,2.243C40.741,49.102,40.423,49,40,49    c-1,0-2,1.111-2,2.222c0,2.931,0.774,6.717,3,7.59v3.53c0,1.061,0.422,2.079,1.172,2.829l6.071,6.068    c1.125,1.125,2.651,1.757,4.242,1.757H55V47H41.063z",
    style: {
      fill: "#CC9978"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51,62h8c0,0,0,3-4,3S51,62,51,62z",
    style: {
      fill: "#9C6144"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.994,50.997c0-1.104-0.896-2-2-2c-0.002,0-0.004,0-0.006,0     c0.001,0.021,0.006,0.041,0.006,0.062c0,1.103-0.892,1.996-1.994,2c0.033,1.075,0.91,1.938,1.994,1.938     C51.098,52.997,51.994,52.102,51.994,50.997z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.987,50.997c0-1.104-0.896-2-2-2c-0.002,0-0.004,0-0.006,0     c0.001,0.021,0.006,0.041,0.006,0.062c0,1.103-0.892,1.996-1.994,2c0.033,1.075,0.91,1.938,1.994,1.938     C61.092,52.997,61.987,52.102,61.987,50.997z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72,31.5c0-3.59-2.91-6.5-6.5-6.5c-1.502,0-2.882,0.515-3.983,1.371      C60.067,24.333,57.691,23,55,23s-5.067,1.333-6.517,3.371C47.382,25.515,46.002,25,44.5,25c-3.59,0-6.5,2.91-6.5,6.5      c0,2.3,1.198,4.316,3,5.472V47h28V36.972C70.802,35.816,72,33.8,72,31.5z",
    style: {
      fill: "#F1F2F2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9,
    style: {
      fill: "#E2E4E5"
    },
    width: 2,
    x: 61,
    y: 36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55,47V23c-2.691,0-5.067,1.333-6.517,3.371C47.382,25.515,46.002,25,44.5,25      c-3.59,0-6.5,2.91-6.5,6.5c0,2.3,1.198,4.316,3,5.472V47H55z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9,
    style: {
      fill: "#E2E4E5"
    },
    width: 2,
    x: 54,
    y: 36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9,
    style: {
      fill: "#E2E4E5"
    },
    width: 2,
    x: 47,
    y: 36
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "66,47 66,53 67,53 69,49 69,47   ",
    style: {
      fill: "#3E3E3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41,47 41,49 43,53 44,53 44,47   ",
    style: {
      fill: "#3E3E3F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55,60c-2-3-7-1-9,2c3,0,9,0,9,0V60z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55,60c2-3,7-1,9,2c-3,0-9,0-9,0V60z",
    style: {
      fill: "#3E3E3F"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefIcon);
export default __webpack_public_path__ + "static/media/chef-icon.866e076bd2347712ef1d5cb77189d5fb.svg";
export { ForwardRef as ReactComponent };